module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-nl.acc102641a56f5e042f7.svg";